import { render, staticRenderFns } from "./blackModal.vue?vue&type=template&id=6b711544&scoped=true&"
import script from "./blackModal.vue?vue&type=script&lang=js&"
export * from "./blackModal.vue?vue&type=script&lang=js&"
import style0 from "./blackModal.vue?vue&type=style&index=0&id=6b711544&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b711544",
  null
  
)

export default component.exports